export type AppBarVariant = "authenticated" | "public";

export const resolveAppBarChrome = ({
	variant,
	hideCommandBar,
	hideExamSwitcher,
	hideMenu,
}: {
	variant: AppBarVariant;
	hideCommandBar?: boolean;
	hideExamSwitcher?: boolean;
	hideMenu?: boolean;
}) => ({
	hideCommandBar: variant === "public" || Boolean(hideCommandBar),
	hideExamSwitcher: variant === "public" || Boolean(hideExamSwitcher),
	hideMenu: variant === "public" || Boolean(hideMenu),
});
